import { render, staticRenderFns } from "./adjust-entries-form.vue?vue&type=template&id=353a6236&scoped=true&"
import script from "./adjust-entries-form.vue?vue&type=script&lang=ts&"
export * from "./adjust-entries-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353a6236",
  null
  
)

export default component.exports